import { Routes, Route } from 'react-router-dom';
import HomePage from './routes/HomePage';
import TutorialPage from './routes/TutorialPage';
import ChallengePage from './routes/ChallengePage';
import SandboxPage from './routes/SandboxPage';
import EscapeRoomPage from './routes/EscapeRoomPage';
import SettingsPage from './routes/SettingsPage';
import { LoginPage } from './pages/LoginPage';
import { SignUpPage } from './pages/SignUpPage';
import { LeaderboardPage } from './pages/LeaderboardPage';
import { ProtectedRoute } from './components/ProtectedRoute';

export function AppRouter() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/sandbox/:templateId?" element={<SandboxPage />} />

      {/* Protected routes - require authentication */}
      <Route
        path="/tutorial/:levelId?"
        element={
          <ProtectedRoute>
            <TutorialPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/challenge/:challengeId?"
        element={
          <ProtectedRoute>
            <ChallengePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/escape-room/:roomId?"
        element={
          <ProtectedRoute>
            <EscapeRoomPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/leaderboard"
        element={
          <ProtectedRoute>
            <LeaderboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
